import { Component, h, render } from "preact";
import {
  INJECT_ELEMENT_CLASS,
  INJECT_WRAPPER_ELEMENT,
  PRODUCT_ELEMENT,
  PRODUCT_UID_ATTR,
} from "@/constants/selectors";

import $ from "jquery";
import ReviewsListCollapse from "@/components/ReviewsListCollapse/ReviewsListCollapse";
import Stars from "@/components/ProductRating/ProductRating";
import { awaitAjaxStopPromise } from "@/utils/awaitAjaxStop";
import { boundActions } from "@store/actions";
import { getProducts } from "@api/index";

export async function initBlock744() {
  // TODO: Поменять это решение, на отслеживание изменений DOM дерева
  await awaitAjaxStopPromise;

  // 1. Функция получает массив блоков своего типа

  const blocksJqElements = $('[data-record-type="744"], .t744');

  const productsJqElements = blocksJqElements.find(PRODUCT_ELEMENT);

  /**
   * @type {String[]}
   */
  const productsIds = productsJqElements
    .toArray()
    .map((el) => $(el).attr(PRODUCT_UID_ATTR));

  // 2. Отправка запроса на получение данных и запись их в стейт

  getProducts(productsIds).then((productsData) => {
    const loadedProductsData = productsData.reduce((acc, val) => {
      const productJqElement = productsJqElements
        .filter((_, el) => $(el).attr(PRODUCT_UID_ATTR) === val.uid)
        .eq(0);

      return {
        ...acc,
        [val.uid]: {
          ...val,
          ...{
            image: productJqElement
              .find(".js-product-img")
              .first()
              .attr("data-original"),
            name: productJqElement.find(".js-product-name").first().text(),
            price: Number.parseFloat(
              productJqElement
                .find(".js-store-prod-price-val")
                .first()
                .text()
                .replaceAll(" ", "")
                .replaceAll(".", "")
                .replaceAll(",", "")
                .trim()
            ),
          },
        },
      };
    }, {});

    productsIds.forEach((uid, idx) => {
      const productJqElement = productsJqElements.eq(idx);

      if (loadedProductsData[uid] === undefined) {
        loadedProductsData[uid] = {
          rating: 0,
          reviews_count: 0,
          image: productJqElement
            .find(".js-product-img")
            .first()
            .attr("data-original"),
          name: productJqElement.find(".js-product-name").first().text(),
          price: Number.parseFloat(
            productJqElement
              .find(".js-store-prod-price-val")
              .first()
              .text()
              .replaceAll(" ", "")
              .replaceAll(".", "")
              .replaceAll(",", "")
              .trim()
          ),
          uid,
        };
      }
    });

    boundActions.setProducts(loadedProductsData);
  });

  // 3. Встраивание компонентов плагина

  blocksJqElements.each((_, blockElement) => {
    const blockJqElement = $(blockElement);

    blockJqElement.find(`.${INJECT_ELEMENT_CLASS}`).remove();

    const productUid = blockJqElement
      .find(PRODUCT_ELEMENT)
      .attr(PRODUCT_UID_ATTR);

    // Индикатор рейтинга в карточке товара
    const starsMiniEl = $(INJECT_WRAPPER_ELEMENT);
    blockJqElement.find(".js-product-name").first().before(starsMiniEl);
    render(<Stars productUid={productUid} />, starsMiniEl.get(0));

    // Список отзывов (коллапс)
    const rewiewsListCollapseEl = $(INJECT_WRAPPER_ELEMENT);
    blockJqElement.find(".js-product").after(rewiewsListCollapseEl);
    render(
      <ReviewsListCollapse productUid={productUid} />,
      rewiewsListCollapseEl.get(0)
    );
  });
}
